import { otherFundingSectionValidationMap } from 'mittweida/inquiry/steps/fundingDetails/sections/otherFundingSection/fieldValidations';

export const mittweidaFundingDetailsFieldValidation = {
  ...otherFundingSectionValidationMap,
};
